import { Button, Col, notification, Row, Tag } from 'antd';
import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DataGrid from 'components/theme_components/DataGrid';
import DF from 'DisplayFramework';
import HeroTitle from 'components/theme_components/HeroTitle';
import {
  CheckOutlined,
  CloseOutlined,
  DownloadOutlined,
  PlusOutlined,
  RightOutlined,
} from '@ant-design/icons';
import { FilterConfig, FilterValues } from 'types';
import { useForm } from 'antd/es/form/Form';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { AuthContext } from 'components/Auth/Auth';
import ConfirmModal from 'components/theme_components/ThirdParty/ConfirmModal';
import ExportXLS from 'components/theme_components/ExportXLS';
import {
  getOfferListByCriteria,
  GetOfferListByCriteriaParams,
  ParOfferListResponse,
  ParOfferTargetConversionRequest,
} from 'services/pricing';
import { useQuery } from 'react-query';
import TaskSButtonSFS from 'pages/workflow/workflowSFS/TasksButtonSFS';
import { DataGridColDef } from 'components/theme_components/DataGrid/DataGrid';
import { handleStatusOffer, updateStatusOffer } from 'services/workflow';
import { replaceProductAct } from 'services/thirdParty';
import moment from 'moment';

export type ProductListProps = {};

const ProductsList = () => {
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalVisibleDelete, setModalVisibleDelete] = useState(false);
  const [modalVisibleConfirm, setmodalVisibleConfirmVisible] = useState(false);
  const [filterValues, setFilterValues] = useState<FilterValues>({})
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [form] = useForm();
  const mgid = localStorage.getItem('mgid');
  const rowCount = selectedRows.length;
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [item, setItem] = useState('' as any);
  const navigate = useNavigate();
  const { isInspect } = useContext(AuthContext);
const [conversionProducts, setConversionProducts] = useState<ParOfferTargetConversionRequest[]>([]);

  const filterConfig: FilterConfig[] = [
    {
      key: 'PRCODE',
      label: 'prcode',
      type: 'select',
    },
    {
      key: 'offercode',
      label: 'offercode',
      type: 'text',
    },
    {
      key: 'offerlabel',
      label: 'offerlabel',
      type: 'text',
    },
    {
      key: 'OFFERSTAT',
      label: 'status',
      type: 'select',
    },
    {
      key: 'startdate',
      label: 'startdate',
      type: 'date',
    },
    {
      key: 'enddate',
      label: 'enddate',
      type: 'date',
    },
  ];

  const columns: DataGridColDef<any>[] = [
    {
      dataIndex: 'prcode',
      key: 'prcode',
    },
    {
      dataIndex: 'offercode',
      key: 'offercode',
    },
    {
      dataIndex: 'offerlabel',
      key: 'offerlabel',
    },
    {
      dataIndex: 'startdate',
      key: 'startdate',
    },
    {
      dataIndex: 'enddate',
      key: 'enddate',
    },
    {
      dataIndex: 'statuslabel',
      key: 'statuslabel',
      width: '100px',
      render: (status: string, record: any) => {
        let tagColor, icon;
        switch (record?.offerstatus) {
          case 'ACTIVE':
            tagColor = '#D6E9E6';
            icon = <CheckOutlined style={{ color: '#0A7C53' }} />;
            break;
          default:
            tagColor = '#FEEFE9';
            icon = <CloseOutlined style={{ color: '#DD7248' }} />;
            break;
          
        }
        return (
          <Tag
            color={tagColor}
            className="tag-status tag-status-default ml-2 p-2 mt-1 mb-1"
            bordered={false}
            icon={icon}

          >
            {status}
          </Tag>
        );
      },
    },
    {
      key: 'actions',
      render: (offer: any, record: ParOfferListResponse) => {
        return (
          record.offerstatus === "ACTIVE" &&
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
          <span
            style={{ cursor: 'pointer', display: 'inline-block' }}
            onClick={() => {
              setItem(offer);
              setModalVisible(true)
            }}
          >
            <GetLabel
              label="deactivate"
              style={{ color: "#DD7248" }}
            />
          </span>



        )
      },
    },

    {
      key: 'arrow',
      render: (val, record) => <RightOutlined onClick={() => navigate(`/product/recap/${record.offerid}`)} />,
    },
  ];


  const getSearchParams = (currentFilterValues: FilterValues = filterValues) => {
    const { startdate, enddate } = currentFilterValues
    console.log("start date", startdate)
    console.log("end date ", enddate)

    const formattedStartDate = startdate ? moment(startdate).format("YYYY-MM-DD") : ""
    const formattedEndDate = enddate ? moment(enddate).format("YYYY-MM-DD") : ""

    let calculatedDuration = 0
    if (enddate && startdate) {
      // Make sure both are moment objects before calculating difference
      const endMoment = moment.isMoment(enddate) ? enddate : moment(enddate)
      const startMoment = moment.isMoment(startdate) ? startdate : moment(startdate)
      calculatedDuration = endMoment.diff(startMoment, "days")
      console.log("calculated duration", calculatedDuration)
    }

    return {
      mgid: mgid ? Number.parseInt(mgid, 10) : 0,
      prcode: currentFilterValues.prcode || "",
      offercode: currentFilterValues.offercode || ("" as any),
      offerlabel: currentFilterValues.offerlabel || "",
      status: currentFilterValues.status || "",
      finamount: "" as any,
      duration: calculatedDuration,
      startdate: formattedStartDate,
      enddate: formattedEndDate,
    }
  };
  

  // Initial search params
  const initialSearchParams: GetOfferListByCriteriaParams = getSearchParams({})
  const [searchParams, setSearchParams] = useState<GetOfferListByCriteriaParams>(initialSearchParams)

  const {
    data: offerlist,
    refetch,
    isFetching,
  } = useQuery(
    ["getOfferListByCriteria", searchParams],
    () => getOfferListByCriteria({ ...searchParams, mgid: Number(mgid) }).then((res) => res.list || []),
    { refetchOnMount: true, enabled: true },
  )


  const handleFilterSearch = (values: any) => {
    console.log("Filter values:", values)

    setFilterValues(values)

    const newSearchParams = getSearchParams(values)
    setSearchParams(newSearchParams)
  }

  const handleFilterReset = () => {
    const resetValues = {}
    setFilterValues(resetValues)
    setSearchParams(getSearchParams(resetValues))
    form.resetFields()
  }

  const handleRowClick = (record: any) => {
    const updatedSelectedRows = selectedRows.includes(record)
      ? selectedRows.filter((row) => row !== record)
      : [...selectedRows, record];
    setSelectedRows(updatedSelectedRows);
  };


  const disableOffer = async (item: any) => {
    const payload = {
      status: "DISABLED",
      entityId: item.offerid,
      entity: "OFFER",
      taskid: 1445,
      subentity: "",
      subentityid: 0,
      objectreference: `ID : ${item.offerid}`,
      entityAddAttributList: []
    };
  
    try {
      const res = await handleStatusOffer(payload);
      if (res.success == null) {
        setShowErrorModal(true);
      } else if (res.success) {
        refetch();
        setShowSuccessModal(true);
      } else {
        notification.error({ message: res.message });
      }
    } catch (err: any) {
      notification.error({ message: err.message });
    }
  };

  return (
    <DF.Provider pagcode="productlistsfs">
      <HeroTitle
        form={form}
        color="purple"
        title="Liste des produits"
        showFilter
        display
        filterConfig={filterConfig}
        onFilterSearch={handleFilterSearch}
        onFilterReset={handleFilterReset}
        className="productlist"
        noTitleOverlay
      />

      <div className="ut-title-page no-after bg-color-gray">
        <Row justify="space-between" align="middle" className="mb-4 mt-6">
          <Col span={7}>

            <Row>
              <Col>
                <Button
                  disabled={!isInspect && rowCount === 0}
                  className={
                    rowCount !== 0
                      ? 'no-border-radius  filter-item ant-btn-outline-primary bg-color-hover'
                      : 'no-border-radius  filter-item '
                  }
                  icon={<CloseOutlined onClick={() => isInspect && setModalVisibleDelete(true)}/>}
                  onClick={() => !isInspect && setModalVisibleDelete(true)}
                >
                  <GetLabel label="inactiveproduct" />
                </Button>


              </Col>

              <Col>
                <Button
                  className="no-border-radius ant-btn-outline-primary ml-2 filter-item ant-btn-add bg-color-hover"
                  onClick={() => !isInspect && navigate('/product/productcreation')}
                  variant="outlined"
                  type="primary"
                  icon={<PlusOutlined />}
                >
                  <GetLabel label="addproduct" />
                </Button>

              </Col>

            </Row>


          </Col>
          <Col span={11}></Col>
          <Col span={6} className="d-flex justify-end align-center">
            <ExportXLS data={offerlist || []} filename='Products' />
          </Col>
        </Row>

        {/* DataGrid Section */}
        <DataGrid
          columns={columns}
          dataSource={offerlist}
          rowSelection={{
            type: 'checkbox',
            onChange: (selectedRowKeys, selectedRows) => {
              console.log('selectedRowKeys', selectedRowKeys);
              console.log('selectedRows', selectedRows);
              setSelectedRows(selectedRows);
              form.setFieldsValue({ selectedRows: selectedRows });
            },
            hideSelectAll: false,
          }}
         
          rowKey={(record) => record.offerid}
          isLoading={isFetching}
        />
        <ConfirmModal
          visible={modalVisibleDelete}
          status="error"
          message={<GetLabel label='' />}
          onConfirm={() => {
            setModalVisibleDelete(false);
          }}
          onCancel={() => !isInspect && setModalVisibleDelete(false)}
          className="modalConfirmOrCancel"
        />
        <ConfirmModal
          visible={modalVisible}
          status="error"
          message="Êtes-vous sûr de vouloir désactiver ce produit ? "
          description=""
          onConfirm={async () => {
           !isInspect && setConfirmLoading(true);
           !isInspect && await disableOffer(item);
            !isInspect &&setModalVisible(false);
            !isInspect &&setConfirmLoading(false);
          }}
          onCancel={() => !isInspect && setModalVisible(false)}
          confirmLoading={confirmLoading} 
          className="modalConfirmOrCancel"
        />
        <ConfirmModal
          visible={modalVisibleConfirm}
          status="success"
          message="Le produit a été remplacé avec succès."
          onConfirm={() => {
            !isInspect && setmodalVisibleConfirmVisible(false);
          }}
          onCancel={() => !isInspect && setmodalVisibleConfirmVisible(false)}
          Confirmcomcode="close"
          onlyConfirm
          className="modalConfirmOrCancel"
        />

        <ConfirmModal
          visible={showErrorModal}
          status="error"
          message="vous tentez de désativer un produit défini comme produit par défault"
          onConfirm={async (newOffer) => {
            setConfirmLoading(true);
            await replaceProductAct({
              sourceOfferId: item?.offerid ,
              targetOfferId: newOffer  
            }).then(res=>{
              if(res.data){
                const payload = {
                  status: "DISABLED",
                  entityId: item?.offerid,
                  entity: "OFFER",
                  taskid: 1445,
                  subentity: "",
                  subentityid: 0,
                  objectreference: `ID : ${item.offerid}`,
                  entityAddAttributList: []
                };
                updateStatusOffer(payload).then(res => {
                  if (res.success) {
                    refetch();
                    setmodalVisibleConfirmVisible(true)
                  }
                })
                .catch(err=>{notification.error({ message: err.message });})
              }
            }).catch(err=>{notification.error({ message: err.message });})
            setConfirmLoading(false);
            setShowErrorModal(false);
          }}
          onCancel={() => !isInspect && setShowErrorModal(false)}
          confirmLoading={confirmLoading} 
          className="modalConfirmOrCancel"
          showOfferInput
          prcode={item?.prcode}
          offerid={item?.offerid}
        />
        <ConfirmModal
          visible={showSuccessModal}
          status="success"
          message="Le produit est maintenant inactif"
          description="2VN02 - SVN AC VARIABELE RENTE V.A."
          onConfirm={() => {
            !isInspect && setShowSuccessModal(false);
          }}
          Confirmcomcode="close"
          onlyConfirm
          className="modalConfirmOrCancel"
        />
      </div>
    </DF.Provider>
  );
};

export default ProductsList;
